import React, { useState } from 'react';
import { Button, Row, Col } from 'react-bootstrap';
import DatePicker from "react-multi-date-picker";

export const HistoricalRecordForm = ({ onDateFilterChange, onClearAllFilters }) => {
    const [dateRange, setDateRange] = useState([]);

    const handleDateRangeChange = (dates) => {
        setDateRange(dates);
        if (dates && dates.length === 2) {
            const startDate = dates[0].format('YYYY-MM-DD');
            const endDate = dates[1].format('YYYY-MM-DD');
            onDateFilterChange({ startDate, endDate });
        } else if (dates && dates.length === 1) {
            const singleDate = dates[0].format('YYYY-MM-DD');
            onDateFilterChange({ startDate: singleDate, endDate: singleDate });
        } else {
            onDateFilterChange({ startDate: null, endDate: null });
        }
    };

    const clearFilters = () => {
        setDateRange([]);
        onDateFilterChange({ startDate: null, endDate: null });

        if (onClearAllFilters) {
            onClearAllFilters();
        }
    };

    return (
        <div className="mt-3">
            <Row className="mb-3">
                <Col md={8}>
                    <div>
                        <label className="form-label">Seleccionar Fecha o Rango de Fechas:</label>
                        <DatePicker
                            value={dateRange}
                            onChange={handleDateRangeChange}
                            range
                            format="YYYY-MM-DD"
                            placeholder="Selecciona una fecha o rango de fechas"
                            style={{
                                width: "100%",
                                height: "38px",
                                fontSize: "14px",
                                padding: "6px 12px",
                                border: "1px solid #ced4da",
                                borderRadius: "4px"
                            }}
                            containerStyle={{
                                width: "100%"
                            }}
                        />
                    </div>
                </Col>
            </Row>

            <Row>
                <Col md={12}>
                    <div className="d-flex gap-2">
                        <Button 
                            variant="primary" 
                            size="sm"
                            onClick={clearFilters}
                        >
                            Limpiar Filtros
                        </Button>
                    </div>
                </Col>
            </Row>
        </div>
    );
};